import { sendRequest } from '../../config';

export interface topesTipolocalizadorParams {
    cpais: string;
    cciaseg: string;
    ccliente: string;
    cplan: string;
    ccedaseg: string;
    ctipoloc: string;
    fcita: string;
    fdesde_pol: string;
    fhasta_pol: string;
}

export interface dataTopesTipolocalizador {
    mensaje: string;
    codigo_error: string;
    supera_tope: number;
    fproximacita?: string ;
    tope_aplicado?: string ;
    frecuencia_aplicada?: string;
    tipo_tope?: string;
    mensaje_conjunto?: string ;

}

export const topesTipolocalizador = async (params: topesTipolocalizadorParams): Promise<dataTopesTipolocalizador> => {
    const ENDPOINT = 'v2/topes/tipolocalizador';
    return sendRequest({
        method: 'post',
        path: ENDPOINT,
        body: params,
    });
};